import { Box, chakra } from '@chakra-ui/react';

type Props = {
  documentBlob: Blob | undefined;
  documentName: string;
  width?: number | string;
  height?: number | string;
};

const Image = chakra('img');

export const DocumentPreviewImage = ({ documentBlob, documentName, width, height }: Props) => {
  if (!documentBlob) {
    return null;
  }

  const imageSrc = URL.createObjectURL(documentBlob);
  return (
    <Box mx={4} boxSizing='border-box'>
      <Image
        src={imageSrc}
        alt={documentName}
        style={{ width, height, objectFit: 'contain' }}
        loading='eager'
        decoding='async'
        pb={4}
      />
    </Box>
  );
};
